
// // CronogramaPeriodos.jsx
// // CronogramaPeriodos.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/CronogramaPeriodos.css";

// // const API = "http://localhost:5001/api/cronograma";

// const API = "http://3.236.217.225:5001/api/cronograma";

// const formatearFecha = (f) =>
//   f
//     ? new Date(f).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
//     : "—";

// export default function CronogramaPeriodos() {
//   const [loading, setLoading] = useState(false); // ✅ Declaración única
//   const { token, user } = useAuth();
//   const rol = (user?.rol || user?.role || "").toLowerCase();
//   const tenant_id = user?.tenant_id || null;
//   const sede_id = user?.sede_id || null;
//   const puedeGestionar = ["rector", "coordinador", "secretaria"].includes(rol);

//   // STATES
//   const [anioActivo, setAnioActivo] = useState(null);
//   const [anios, setAnios] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [recuperaciones, setRecuperaciones] = useState([]);
//   const [fechasNotas, setFechasNotas] = useState([]);

//   const [formAnio, setFormAnio] = useState({ anio: "" });
//   const [formPeriodo, setFormPeriodo] = useState({ nombre: "", fecha_inicio: "", fecha_fin: "", porcentaje: "" });
//   const [formRecuperacion, setFormRecuperacion] = useState({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
//   const [formNotas, setFormNotas] = useState({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });

//   const [editAnioId, setEditAnioId] = useState(null);
//   const [editAnioValue, setEditAnioValue] = useState("");
//   const [editPeriodoId, setEditPeriodoId] = useState(null);
//   const [editPeriodo, setEditPeriodo] = useState({});

//   const authHeaders = { headers: { Authorization: `Bearer ${token}` } };
//   const tenantPayload = { tenant_id, sede_id };

//   useEffect(() => {
//     if (!tenant_id) return;
//     fetchAnios();
//   }, [tenant_id]);

//   const totalPorcentaje = useMemo(
//     () => periodos.reduce((acc, p) => acc + Number(p.porcentaje || 0), 0),
//     [periodos]
//   );

//   const validarPorcentaje = (nuevoValor, editId = null) =>
//     periodos.reduce((acc, p) => (editId && p.id === editId ? acc : acc + Number(p.porcentaje || 0)), 0) + Number(nuevoValor || 0) <= 100;

//   const validarRangoFechas = (inicio, fin) => !inicio || !fin ? false : new Date(inicio) <= new Date(fin);

//   // ========================== CRUD AÑOS ==========================
//   const fetchAnios = async () => {
//     try {
//       const res = await axios.get(`${API}/anios`, { ...authHeaders, params: tenantPayload });
//       const lista = res.data.anios || [];
//       setAnios(lista);
//       const activo = lista.find(a => a.activo === 1);
//       if (activo) {
//         setAnioActivo(activo);
//         fetchPeriodos(activo.id);
//         fetchRecuperaciones(activo.id);
//         fetchFechasNotas(activo.id);
//       } else {
//         setAnioActivo(null);
//         setPeriodos([]);
//         setRecuperaciones([]);
//         setFechasNotas([]);
//       }
//     } catch {
//       alert("❌ Error al obtener años.");
//     }
//   };

//   const handleCrearAnio = async () => {
//     if (!puedeGestionar) return alert("No tienes permisos.");
//     if (!formAnio.anio || isNaN(formAnio.anio)) return alert("Ingresa un año válido.");
//     try {
//       setLoading(true);
//       await axios.post(`${API}/anio`, { anio: Number(formAnio.anio), ...tenantPayload }, authHeaders);
//       setFormAnio({ anio: "" });
//       fetchAnios();
//     } catch {
//       alert("❌ Error al crear año");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditarAnio = async (id) => {
//     if (!editAnioValue || isNaN(editAnioValue)) return alert("Año inválido");
//     try {
//       await axios.patch(`${API}/anio/${id}`, { anio: Number(editAnioValue), ...tenantPayload }, authHeaders);
//       setEditAnioId(null);
//       fetchAnios();
//     } catch {
//       alert("❌ Error al actualizar año");
//     }
//   };

//   const handleEliminarAnio = async (id) => {
//     if (!window.confirm("Eliminar año?")) return;
//     try {
//       await axios.delete(`${API}/anio/${id}`, { ...authHeaders, params: tenantPayload });
//       fetchAnios();
//     } catch {
//       alert("❌ Error al eliminar");
//     }
//   };

//   const handleActivarAnio = async (id) => {
//     try {
//       await axios.patch(`${API}/anio/${id}/activar`, tenantPayload, authHeaders);
//       fetchAnios();
//     } catch {
//       alert("❌ Error al activar");
//     }
//   };

//   // ========================== CRUD PERIODOS ==========================
//   const fetchPeriodos = async (anioId) => {
//     if (!anioId) return;
//     try {
//       const res = await axios.get(`${API}/periodos`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: { anio_lectivo_id: anioId, tenant_id, sede_id }
//       });

//       const periodosData = res.data.periodos || [];
//       const maxActivo = periodosData.filter(p => p.activo === 1);
//       if (maxActivo.length > 1) {
//         periodosData.forEach((p, i) => (p.activo = i === 0 ? 1 : 0));
//       }

//       setPeriodos(periodosData);
//     } catch (err) {
//       console.error("Error al traer periodos:", err.response?.data || err.message);
//     }
//   };

//   const handleSubmitPeriodo = async (e) => {
//     e.preventDefault();
//     if (!anioActivo) return alert("No hay año activo");
//     if (!validarPorcentaje(formPeriodo.porcentaje)) return alert("⚠️ Total supera 100%");
//     if (!validarRangoFechas(formPeriodo.fecha_inicio, formPeriodo.fecha_fin)) return alert("Fechas inválidas");
//     try {
//       setLoading(true);
//       const nuevoNumero = periodos.length > 0 ? Math.max(...periodos.map(p => p.numero || 0)) + 1 : 1;
//       await axios.post(
//         `${API}/periodos`,
//         { ...formPeriodo, porcentaje: Number(formPeriodo.porcentaje), numero: nuevoNumero, anio_lectivo_id: anioActivo.id, ...tenantPayload },
//         authHeaders
//       );
//       setFormPeriodo({ nombre: "", fecha_inicio: "", fecha_fin: "", porcentaje: "" });
//       fetchPeriodos(anioActivo.id);
//     } catch {
//       alert("❌ Error al crear periodo");
//     } finally {
//       setLoading(false);
//     }
//   };

// // Convierte string de fecha del input a formato MySQL DATETIME
// const parseDateTime = (dateStr) => {
//   if (!dateStr) return null;
//   const d = new Date(dateStr);
//   const yyyy = d.getFullYear();
//   const mm = String(d.getMonth() + 1).padStart(2, "0");
//   const dd = String(d.getDate()).padStart(2, "0");
//   const hh = String(d.getHours()).padStart(2, "0");
//   const min = String(d.getMinutes()).padStart(2, "0");
//   const ss = String(d.getSeconds()).padStart(2, "0");
//   return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
// };

// // ===================== CREAR PERIODO =====================


// // ===================== EDITAR PERIODO =====================
// const handleEditarPeriodo = async (id) => {
//   if (!validarPorcentaje(editPeriodo.porcentaje, id)) return alert("⚠️ Total supera 100%");
//   if (!validarRangoFechas(editPeriodo.fecha_inicio, editPeriodo.fecha_fin)) return alert("Fechas inválidas");

//   try {
//     await axios.patch(
//       `${API}/periodos/${id}`,
//       {
//         ...editPeriodo,
//         porcentaje: Number(editPeriodo.porcentaje),
//         anio_lectivo_id: anioActivo.id,
//         fecha_inicio: parseDateTime(editPeriodo.fecha_inicio),
//         fecha_fin: parseDateTime(editPeriodo.fecha_fin),
//         tenant_id,
//         sede_id
//       },
//       authHeaders
//     );

//     setEditPeriodoId(null);
//     fetchPeriodos(anioActivo.id);

//   } catch {
//     alert("❌ Error al editar periodo");
//   }
// };


//   const handleEliminarPeriodo = async (id) => {
//     if (!window.confirm("Eliminar periodo?")) return;
//     try {
//       await axios.delete(`${API}/periodos/${id}`, { ...authHeaders, params: tenantPayload });
//       fetchPeriodos(anioActivo.id);
//     } catch {
//       alert("❌ Error al eliminar periodo");
//     }
//   };

//   const handleActivarPeriodo = async (id) => {
//     if (!anioActivo) return alert("No hay año activo");
//     try {
//       await axios.patch(
//         `${API}/periodos/${id}/activar`,
//         { anio_lectivo_id: anioActivo.id },
//         { headers: { Authorization: `Bearer ${token}` }, params: { tenant_id, sede_id } }
//       );
//       await fetchPeriodos(anioActivo.id);
//     } catch (err) {
//       console.error("Error al activar periodo:", err.response?.data || err.message);
//       alert("❌ Error al activar periodo");
//     }
//   };

//   // ========================== CRUD RECUPERACIONES ==========================
//   const fetchRecuperaciones = async (anioId) => {
//     if (!anioId) return;
//     try {
//       const res = await axios.get(`${API}/recuperaciones`, { ...authHeaders, params: { anio_lectivo_id: anioId, ...tenantPayload } });
//       setRecuperaciones(res.data.recuperaciones || []);
//     } catch {
//       console.error("Error recuperaciones");
//     }
//   };

//   const handleSubmitRecuperacion = async (e) => {
//     e.preventDefault();
//     if (!anioActivo) return alert("No hay año activo");
//     if (!formRecuperacion.periodo_id) return alert("Selecciona un periodo");
//     if (!validarRangoFechas(formRecuperacion.fecha_inicio, formRecuperacion.fecha_fin)) return alert("Fechas inválidas");
//     try {
//       setLoading(true);
//       await axios.post(`${API}/recuperaciones`, { ...formRecuperacion, anio_lectivo_id: anioActivo.id, ...tenantPayload }, authHeaders);
//       setFormRecuperacion({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
//       fetchRecuperaciones(anioActivo.id);
//     } catch {
//       alert("❌ Error al guardar recuperación");
//     } finally {
//       setLoading(false);
//     }
//   };

// const handleEliminarRecuperacion = async (id) => {
//   if (!window.confirm("¿Eliminar recuperación?")) return;

//   try {
//     setLoading(true);
//     await axios.delete(`${API}/recuperaciones/${id}`, {
//       headers: { ...authHeaders.headers },
//       params: {
//         tenant_id,
//         sede_id,
//         anio_lectivo_id: anioActivo.id, // ✅ usar el año activo
//       },
//     });

//     fetchRecuperaciones(anioActivo.id);
//     alert("✅ Recuperación eliminada correctamente");
//   } catch (err) {
//     console.error("Error eliminando recuperación:", err);
//     alert(`❌ ${err.response?.data?.message || err.message}`);
//   } finally {
//     setLoading(false);
//   }
// };


//   // ========================== CRUD FECHA LÍMITE DE NOTAS ==========================
//   const fetchFechasNotas = async (anioId) => {
//     if (!anioId) return;
//     try {
//       const res = await axios.get(`${API}/notas`, { ...authHeaders, params: { anio_lectivo_id: anioId, ...tenantPayload } });
//       setFechasNotas(res.data.notas || []);
//     } catch {
//       console.error("Error fechas notas");
//     }
//   };

//   const handleSubmitNotas = async (e) => {
//   e.preventDefault();
//   if (!anioActivo) return alert("No hay año activo");
//   if (!formNotas.periodo_id) return alert("Selecciona periodo");
//   if (!validarRangoFechas(formNotas.fecha_inicio, formNotas.fecha_fin)) return alert("Fechas inválidas");
//   try {
//     setLoading(true);
//     await axios.post(`${API}/notas`, { 
//       ...formNotas, 
//       anio_lectivo_id: anioActivo.id, 
//       ...tenantPayload 
//     }, authHeaders);
//     setFormNotas({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
//     fetchFechasNotas(anioActivo.id);
//     fetchPeriodos(anioActivo.id); // refrescamos periodos
//   } catch {
//     alert("❌ Error al guardar fecha límite de notas");
//   } finally {
//     setLoading(false);
//   }
// };


//   const handleEliminarNotas = async (id) => {
//     if (!window.confirm("Eliminar fecha límite de notas?")) return;
//     try {
//       await axios.delete(`${API}/notas/${id}`, { ...authHeaders, params: tenantPayload });
//       fetchFechasNotas(anioActivo.id);
//       fetchPeriodos(anioActivo.id);
//     } catch {
//       alert("❌ Error al eliminar");
//     }
//   };

//   // ========================== RENDER ==========================


//   // ========================== RENDER ==========================
//   return (
//     <div className="cronograma-container">
//       <h2 className="titulo">📘 Cronograma Académico</h2>
//       {!tenant_id && <p style={{ color: "red" }}>⚠️ Error: sesión sin tenant</p>}
//       {anioActivo && <p><strong>Año activo:</strong> {anioActivo.anio}</p>}
//       {anioActivo && <p><strong>Total % asignado:</strong> <span style={{ color: totalPorcentaje === 100 ? "green" : "red" }}>{totalPorcentaje}%</span></p>}

//       {/* FORM AÑO */}
//       {puedeGestionar && (
//         <div className="form-anio">
//           <h3>🧭 Crear Año Lectivo</h3>
//           <input type="number" placeholder="Ej: 2025" value={formAnio.anio} onChange={e => setFormAnio({ anio: e.target.value || "" })} />
//           <button type="button" onClick={handleCrearAnio} disabled={loading}>{loading ? "Creando..." : "Crear Año"}</button>
//         </div>
//       )}

//       {/* TABLA AÑOS */}
//       {puedeGestionar && (
//         <table className="tabla-cronograma">
//           <thead><tr><th>Año</th><th>Estado</th><th>Acciones</th></tr></thead>
//           <tbody>
//             {anios.map(a => (
//               <tr key={`anio-${a.id}`}>
//                 <td>{editAnioId === a.id ? <input type="number" value={editAnioValue} onChange={e => setEditAnioValue(e.target.value)} /> : a.anio}</td>
//                 <td>{a.activo === 1 ? "🟢 Activo" : "⚪ Inactivo"}</td>
//                 <td>
//                   {editAnioId === a.id ? (
//                     <>
//                       <button onClick={() => handleEditarAnio(a.id)}>💾</button>
//                       <button onClick={() => setEditAnioId(null)}>❌</button>
//                     </>
//                   ) : (
//                     <>
//                       <button onClick={() => { setEditAnioId(a.id); setEditAnioValue(a.anio); }}>✏️</button>
//                       <button onClick={() => handleEliminarAnio(a.id)}>🗑️</button>
//                       <button onClick={() => handleActivarAnio(a.id)} disabled={a.activo === 1}>⚙️</button>
//                     </>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       {/* FORM CREAR PERIODO */}
//       {anioActivo && puedeGestionar && (
//         <form className="form-cronograma" onSubmit={handleSubmitPeriodo}>
//           <h3>📅 Crear Nuevo Periodo</h3>

//           <input
//             type="text"
//             placeholder="Nombre del periodo"
//             value={formPeriodo.nombre}
//             onChange={e => setFormPeriodo({ ...formPeriodo, nombre: e.target.value })}
//             required
//           />

//           <input
//             type="number"
//             placeholder="Porcentaje (%)"
//             value={formPeriodo.porcentaje}
//             onChange={e => setFormPeriodo({ ...formPeriodo, porcentaje: e.target.value })}
//             min="0"
//             max="100"
//             required
//           />

//           <input
//             type="date"
//             value={formPeriodo.fecha_inicio}
//             onChange={e => setFormPeriodo({ ...formPeriodo, fecha_inicio: e.target.value })}
//             required
//           />

//           <input
//             type="date"
//             value={formPeriodo.fecha_fin}
//             onChange={e => setFormPeriodo({ ...formPeriodo, fecha_fin: e.target.value })}
//             required
//           />

//           <button type="submit" disabled={loading}>
//             {loading ? "Guardando..." : "Crear Periodo"}
//           </button>
//         </form>
//       )}

//       {/* TABLA PERIODOS */}
//       {anioActivo && (
//         <table className="tabla-cronograma">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Nombre</th>
//               <th>%</th>
//               <th>Inicio</th>
//               <th>Fin</th>
//               <th>Fecha Límite Notas</th>
//               <th>Fechas Recuperaciones</th>
//               <th>Activo</th>
//               <th>Acciones</th>
//             </tr>
//           </thead>
//      <tbody>
//   {periodos.map((p, idx) => {
//     // Filtramos las recuperaciones del periodo actual
//     const recsPeriodo = recuperaciones.filter(
//       r => r.periodo_id === p.id && r.tenant_id === tenant_id && (sede_id ? r.sede_id === sede_id : true)
//     );

//     // Obtenemos la fecha límite de subida de notas
//     const notaPeriodo = fechasNotas.find(n => n.periodo_id === p.id);

//     return (
//       <tr key={p.id}>
//         <td>{idx + 1}</td>
//         <td>
//           {editPeriodoId === p.id ? (
//             <input 
//               value={editPeriodo.nombre} 
//               onChange={e => setEditPeriodo({ ...editPeriodo, nombre: e.target.value })} 
//             />
//           ) : (
//             p.nombre
//           )}
//         </td>
//         <td>
//           {editPeriodoId === p.id ? (
//             <input 
//               type="number" 
//               value={editPeriodo.porcentaje} 
//               onChange={e => setEditPeriodo({ ...editPeriodo, porcentaje: e.target.value })} 
//             />
//           ) : (
//             Number(p.porcentaje || 0).toFixed(2) + "%"
//           )}
//         </td>
//         <td>
//           {editPeriodoId === p.id ? (
//             <input 
//               type="date" 
//               value={editPeriodo.fecha_inicio} 
//               onChange={e => setEditPeriodo({ ...editPeriodo, fecha_inicio: e.target.value })} 
//             />
//           ) : (
//             formatearFecha(p.fecha_inicio)
//           )}
//         </td>
//         <td>
//           {editPeriodoId === p.id ? (
//             <input 
//               type="date" 
//               value={editPeriodo.fecha_fin} 
//               onChange={e => setEditPeriodo({ ...editPeriodo, fecha_fin: e.target.value })} 
//             />
//           ) : (
//             formatearFecha(p.fecha_fin)
//           )}
//         </td>

//         {/* Fecha límite de subida de notas */}
//         <td>
//           {notaPeriodo
//             ? `${formatearFecha(notaPeriodo.fecha_inicio)} → ${formatearFecha(notaPeriodo.fecha_fin)}`
//             : "—"
//           }
//         </td>

//         {/* Recuperaciones: fechas + nota final */}
//         <td>
//           {recsPeriodo.length ? recsPeriodo.map(r => {
//             const notaFinal = r.nota_final !== undefined ? ` | Nota: ${r.nota_final}` : "";
//             return `${formatearFecha(r.fecha_inicio)} → ${formatearFecha(r.fecha_fin)}${notaFinal}`;
//           }).join(", ") : "—"}
//         </td>

//         <td>{p.activo ? "✅" : "❎"}</td>

//         <td>
//           {puedeGestionar && (
//             <>
//               {editPeriodoId === p.id ? (
//                 <>
//                   <button onClick={() => handleEditarPeriodo(p.id)}>💾</button>
//                   <button onClick={() => setEditPeriodoId(null)}>❌</button>
//                 </>
//               ) : (
//                 <>
//                   <button onClick={() => { setEditPeriodoId(p.id); setEditPeriodo({ ...p }); }}>✏️</button>
//                   <button onClick={() => handleEliminarPeriodo(p.id)}>🗑️</button>
//                   <button onClick={() => handleActivarPeriodo(p.id)} disabled={!!p.activo}>⚙️</button>
//                 </>
//               )}
//             </>
//           )}
//         </td>
//       </tr>
//     );
//   })}
// </tbody>

//         </table>
//       )}

//       {/* FORM RECUPERACIONES */}
//       {anioActivo && (
//         <>
//           <form className="form-cronograma" onSubmit={handleSubmitRecuperacion}>
//             <h3>♻️ Fecha de recuperación</h3>
//             <select value={formRecuperacion.periodo_id} onChange={e => setFormRecuperacion({ ...formRecuperacion, periodo_id: e.target.value })} required>
//               <option value="">Selecciona periodo</option>
//               {periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//             </select>
//             <input type="date" value={formRecuperacion.fecha_inicio} onChange={e => setFormRecuperacion({ ...formRecuperacion, fecha_inicio: e.target.value })} required />
//             <input type="date" value={formRecuperacion.fecha_fin} onChange={e => setFormRecuperacion({ ...formRecuperacion, fecha_fin: e.target.value })} required />
//             <button type="submit">Guardar</button>
//           </form>

//           <table className="tabla-cronograma">
//             <thead><tr><th>Periodo</th><th>Inicio Recuperación</th><th>Fin Recuperación</th><th>Fecha límite Notas</th><th>Acciones</th></tr></thead>
//             <tbody>
//               {recuperaciones.map(r => {
//                 const periodo = periodos.find(p => p.id === r.periodo_id);
//                 const notaPeriodo = fechasNotas.find(n => n.periodo_id === r.periodo_id);
//                 return (
//                   <tr key={`rec-${r.id}`}>
//                     <td>{periodo?.nombre || "—"}</td>
//                     <td>{formatearFecha(r.fecha_inicio)}</td>
//                     <td>{formatearFecha(r.fecha_fin)}</td>
//                     <td>{notaPeriodo ? `${formatearFecha(notaPeriodo.fecha_inicio)} → ${formatearFecha(notaPeriodo.fecha_fin)}` : "—"}</td>
//                     <td><button onClick={() => handleEliminarRecuperacion(r.id)}>🗑️</button></td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </>
//       )}

//       {/* FORM NOTAS */}
// {anioActivo && puedeGestionar && (
//   <>
//     <form className="form-cronograma" onSubmit={handleSubmitNotas}>
//       <h3>📝 Fecha límite para subir notas</h3>
//       <select
//         value={formNotas.periodo_id}
//         onChange={e => setFormNotas({ ...formNotas, periodo_id: e.target.value })}
//         required
//       >
//         <option value="">Selecciona periodo</option>
//         {periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//       </select>
//       <input
//         type="date"
//         value={formNotas.fecha_inicio}
//         onChange={e => setFormNotas({ ...formNotas, fecha_inicio: e.target.value })}
//         required
//       />
//       <input
//         type="date"
//         value={formNotas.fecha_fin}
//         onChange={e => setFormNotas({ ...formNotas, fecha_fin: e.target.value })}
//         required
//       />
//       <button type="submit" disabled={loading}>
//         {loading ? "Guardando..." : "Guardar"}
//       </button>
//     </form>

//     <table className="tabla-cronograma">
//       <thead>
//         <tr>
//           <th>Periodo</th>
//           <th>Inicio</th>
//           <th>Fin</th>
//           <th>Nota Final</th>
//           <th>Acciones</th>
//         </tr>
//       </thead>
//       <tbody>
//         {fechasNotas.map(n => {
//           const periodo = periodos.find(p => p.id === n.periodo_id);
//           return (
//             <tr key={`nota-${n.id}`}>
//               <td>{periodo?.nombre || "—"}</td>
//               <td>{formatearFecha(n.fecha_inicio)}</td>
//               <td>{formatearFecha(n.fecha_fin)}</td>
//               <td>{n.nota_final != null ? n.nota_final.toFixed(2) : "—"}</td>
//               <td>
//                 <button
//                   onClick={() => handleEliminarNotas(n.id)}
//                   disabled={loading}
//                 >
//                   {loading ? "Eliminando..." : "🗑️"}
//                 </button>
//               </td>
//             </tr>
//           );
//         })}
//       </tbody>
//     </table>
//   </>
// )}


//     </div>
//   );
// }



//

import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API } from '../config'; // ✅ Importación solicitada
import "../../style/CronogramaPeriodos.css";

const formatearFecha = (f) =>
  f
    ? new Date(f).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
    : "—";

export default function CronogramaPeriodos() {
  const [loading, setLoading] = useState(false);
  const { token, user } = useAuth();
  
  // Contexto de usuario
  const rol = (user?.rol || user?.role || "").toLowerCase();
  const tenant_id = user?.tenant_id || null;
  const sede_id = user?.sede_id || null;
  const puedeGestionar = ["rector", "coordinador", "secretaria"].includes(rol);

  // Estados de datos
  const [anioActivo, setAnioActivo] = useState(null);
  const [anios, setAnios] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [recuperaciones, setRecuperaciones] = useState([]);
  const [fechasNotas, setFechasNotas] = useState([]);

  // Estados de formulario
  const [formAnio, setFormAnio] = useState({ anio: "" });
  const [formPeriodo, setFormPeriodo] = useState({ nombre: "", fecha_inicio: "", fecha_fin: "", porcentaje: "" });
  const [formRecuperacion, setFormRecuperacion] = useState({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
  const [formNotas, setFormNotas] = useState({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });

  // Estados de edición
  const [editAnioId, setEditAnioId] = useState(null);
  const [editAnioValue, setEditAnioValue] = useState("");
  const [editPeriodoId, setEditPeriodoId] = useState(null);
  const [editPeriodo, setEditPeriodo] = useState({});

  const authHeaders = { headers: { Authorization: `Bearer ${token}` } };
  const tenantPayload = { tenant_id, sede_id };

  // ========================== CARGA DE DATOS ==========================
  const fetchAnios = useCallback(async () => {
    if (!tenant_id) return;
    try {
      const res = await axios.get(`${API}/cronograma/anios`, { ...authHeaders, params: tenantPayload });
      const lista = res.data.anios || [];
      setAnios(lista);
      const activo = lista.find(a => a.activo === 1);
      if (activo) {
        setAnioActivo(activo);
        fetchPeriodos(activo.id);
        fetchRecuperaciones(activo.id);
        fetchFechasNotas(activo.id);
      }
    } catch (err) {
      console.error("❌ Error al obtener años:", err);
    }
  }, [tenant_id, token]);

  useEffect(() => {
    fetchAnios();
  }, [fetchAnios]);

  const totalPorcentaje = useMemo(
    () => periodos.reduce((acc, p) => acc + Number(p.porcentaje || 0), 0),
    [periodos]
  );

  const validarPorcentaje = (nuevoValor, editId = null) =>
    periodos.reduce((acc, p) => (editId && p.id === editId ? acc : acc + Number(p.porcentaje || 0)), 0) + Number(nuevoValor || 0) <= 100;

  const validarRangoFechas = (inicio, fin) => !inicio || !fin ? false : new Date(inicio) <= new Date(fin);

  const parseDateTime = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return d.toISOString().slice(0, 19).replace('T', ' '); 
  };

  // ========================== CRUD AÑOS ==========================
  const handleCrearAnio = async () => {
    if (!formAnio.anio || isNaN(formAnio.anio)) return alert("Ingresa un año válido.");
    try {
      setLoading(true);
      await axios.post(`${API}/cronograma/anio`, { anio: Number(formAnio.anio), ...tenantPayload }, authHeaders);
      setFormAnio({ anio: "" });
      fetchAnios();
    } catch { alert("❌ Error al crear año"); } finally { setLoading(false); }
  };

  const handleEditarAnio = async (id) => {
    try {
      await axios.patch(`${API}/cronograma/anio/${id}`, { anio: Number(editAnioValue), ...tenantPayload }, authHeaders);
      setEditAnioId(null);
      fetchAnios();
    } catch { alert("❌ Error al actualizar año"); }
  };

  const handleEliminarAnio = async (id) => {
    if (!window.confirm("¿Eliminar año?")) return;
    try {
      await axios.delete(`${API}/cronograma/anio/${id}`, { ...authHeaders, params: tenantPayload });
      fetchAnios();
    } catch { alert("❌ Error al eliminar"); }
  };

  const handleActivarAnio = async (id) => {
    try {
      await axios.patch(`${API}/cronograma/anio/${id}/activar`, tenantPayload, authHeaders);
      fetchAnios();
    } catch { alert("❌ Error al activar"); }
  };

  // ========================== CRUD PERIODOS ==========================
  const fetchPeriodos = async (anioId) => {
    try {
      const res = await axios.get(`${API}/cronograma/periodos`, {
        ...authHeaders,
        params: { anio_lectivo_id: anioId, ...tenantPayload }
      });
      setPeriodos(res.data.periodos || []);
    } catch (err) { console.error("Error al traer periodos", err); }
  };

  const handleSubmitPeriodo = async (e) => {
    e.preventDefault();
    if (!validarPorcentaje(formPeriodo.porcentaje)) return alert("⚠️ Total supera 100%");
    try {
      setLoading(true);
      const nuevoNumero = periodos.length > 0 ? Math.max(...periodos.map(p => p.numero || 0)) + 1 : 1;
      await axios.post(`${API}/cronograma/periodos`, 
        { ...formPeriodo, porcentaje: Number(formPeriodo.porcentaje), numero: nuevoNumero, anio_lectivo_id: anioActivo.id, ...tenantPayload },
        authHeaders
      );
      setFormPeriodo({ nombre: "", fecha_inicio: "", fecha_fin: "", porcentaje: "" });
      fetchPeriodos(anioActivo.id);
    } catch { alert("❌ Error al crear periodo"); } finally { setLoading(false); }
  };

  const handleEditarPeriodo = async (id) => {
    if (!validarPorcentaje(editPeriodo.porcentaje, id)) return alert("⚠️ Total supera 100%");
    try {
      await axios.patch(`${API}/cronograma/periodos/${id}`, {
        ...editPeriodo,
        porcentaje: Number(editPeriodo.porcentaje),
        anio_lectivo_id: anioActivo.id,
        fecha_inicio: parseDateTime(editPeriodo.fecha_inicio),
        fecha_fin: parseDateTime(editPeriodo.fecha_fin),
        ...tenantPayload
      }, authHeaders);
      setEditPeriodoId(null);
      fetchPeriodos(anioActivo.id);
    } catch { alert("❌ Error al editar periodo"); }
  };

  const handleActivarPeriodo = async (id) => {
    try {
      await axios.patch(`${API}/cronograma/periodos/${id}/activar`, 
        { anio_lectivo_id: anioActivo.id },
        { ...authHeaders, params: tenantPayload }
      );
      fetchPeriodos(anioActivo.id);
    } catch { alert("❌ Error al activar periodo"); }
  };

  // ========================== CRUD RECUPERACIONES ==========================
  const fetchRecuperaciones = async (anioId) => {
    try {
      const res = await axios.get(`${API}/cronograma/recuperaciones`, { ...authHeaders, params: { anio_lectivo_id: anioId, ...tenantPayload } });
      setRecuperaciones(res.data.recuperaciones || []);
    } catch { console.error("Error recuperaciones"); }
  };

  const handleSubmitRecuperacion = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.post(`${API}/cronograma/recuperaciones`, { ...formRecuperacion, anio_lectivo_id: anioActivo.id, ...tenantPayload }, authHeaders);
      setFormRecuperacion({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
      fetchRecuperaciones(anioActivo.id);
    } catch { alert("❌ Error al guardar recuperación"); } finally { setLoading(false); }
  };

  const handleEliminarRecuperacion = async (id) => {
    if (!window.confirm("¿Eliminar?")) return;
    try {
      await axios.delete(`${API}/cronograma/recuperaciones/${id}`, { ...authHeaders, params: { ...tenantPayload, anio_lectivo_id: anioActivo.id } });
      fetchRecuperaciones(anioActivo.id);
    } catch { alert("❌ Error"); }
  };

  // ========================== CRUD NOTAS ==========================
  const fetchFechasNotas = async (anioId) => {
    try {
      const res = await axios.get(`${API}/cronograma/notas`, { ...authHeaders, params: { anio_lectivo_id: anioId, ...tenantPayload } });
      setFechasNotas(res.data.notas || []);
    } catch { console.error("Error notas"); }
  };

  const handleSubmitNotas = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axios.post(`${API}/cronograma/notas`, { ...formNotas, anio_lectivo_id: anioActivo.id, ...tenantPayload }, authHeaders);
      setFormNotas({ periodo_id: "", fecha_inicio: "", fecha_fin: "" });
      fetchFechasNotas(anioActivo.id);
    } catch { alert("❌ Error"); } finally { setLoading(false); }
  };

  return (
    <div className="cronograma-container">
      <h2 className="titulo">📘 Cronograma Académico</h2>
      {anioActivo && (
        <div className="info-bar">
          <p><strong>Año:</strong> {anioActivo.anio} | <strong>Total %:</strong> <span style={{ color: totalPorcentaje === 100 ? "green" : "red" }}>{totalPorcentaje}%</span></p>
        </div>
      )}

      {/* SECCIÓN AÑOS */}
      {puedeGestionar && (
        <section className="seccion-cronograma">
          <h3>🧭 Gestión de Años Lectivos</h3>
          <div className="form-inline">
            <input type="number" placeholder="Ej: 2025" value={formAnio.anio} onChange={e => setFormAnio({ anio: e.target.value })} />
            <button onClick={handleCrearAnio} disabled={loading}>Crear</button>
          </div>
          <table className="tabla-cronograma">
            <thead><tr><th>Año</th><th>Estado</th><th>Acciones</th></tr></thead>
            <tbody>
              {anios.map(a => (
                <tr key={a.id}>
                  <td>{editAnioId === a.id ? <input type="number" value={editAnioValue} onChange={e => setEditAnioValue(e.target.value)} /> : a.anio}</td>
                  <td>{a.activo ? "🟢 Activo" : "⚪ Inactivo"}</td>
                  <td>
                    {editAnioId === a.id ? (
                      <button onClick={() => handleEditarAnio(a.id)}>💾</button>
                    ) : (
                      <>
                        <button onClick={() => { setEditAnioId(a.id); setEditAnioValue(a.anio); }}>✏️</button>
                        <button onClick={() => handleActivarAnio(a.id)} disabled={a.activo}>⚙️</button>
                        <button onClick={() => handleEliminarAnio(a.id)}>🗑️</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {/* SECCIÓN PERIODOS */}
      {anioActivo && (
        <section className="seccion-cronograma">
          <h3>📅 Periodos del Año {anioActivo.anio}</h3>
          {puedeGestionar && (
            <form className="form-cronograma" onSubmit={handleSubmitPeriodo}>
              <input type="text" placeholder="Nombre" value={formPeriodo.nombre} onChange={e => setFormPeriodo({ ...formPeriodo, nombre: e.target.value })} required />
              <input type="number" placeholder="%" value={formPeriodo.porcentaje} onChange={e => setFormPeriodo({ ...formPeriodo, porcentaje: e.target.value })} required />
              <input type="date" value={formPeriodo.fecha_inicio} onChange={e => setFormPeriodo({ ...formPeriodo, fecha_inicio: e.target.value })} required />
              <input type="date" value={formPeriodo.fecha_fin} onChange={e => setFormPeriodo({ ...formPeriodo, fecha_fin: e.target.value })} required />
              <button type="submit">＋ Crear Periodo</button>
            </form>
          )}

          <table className="tabla-cronograma">
            <thead>
              <tr>
                <th>#</th><th>Nombre</th><th>%</th><th>Vigencia</th><th>Límite Notas</th><th>Estado</th><th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {periodos.map((p, idx) => {
                const nota = fechasNotas.find(n => n.periodo_id === p.id);
                return (
                  <tr key={p.id}>
                    <td>{idx + 1}</td>
                    <td>{editPeriodoId === p.id ? <input value={editPeriodo.nombre} onChange={e => setEditPeriodo({ ...editPeriodo, nombre: e.target.value })} /> : p.nombre}</td>
                    <td>{editPeriodoId === p.id ? <input type="number" value={editPeriodo.porcentaje} onChange={e => setEditPeriodo({ ...editPeriodo, porcentaje: e.target.value })} /> : `${p.porcentaje}%`}</td>
                    <td>{formatearFecha(p.fecha_inicio)} - {formatearFecha(p.fecha_fin)}</td>
                    <td>{nota ? formatearFecha(nota.fecha_fin) : "—"}</td>
                    <td>{p.activo ? "✅" : "❎"}</td>
                    <td>
                      {puedeGestionar && (
                        editPeriodoId === p.id ? (
                          <button onClick={() => handleEditarPeriodo(p.id)}>💾</button>
                        ) : (
                          <>
                            <button onClick={() => { setEditPeriodoId(p.id); setEditPeriodo({ ...p }); }}>✏️</button>
                            <button onClick={() => handleActivarPeriodo(p.id)} disabled={p.activo}>⚙️</button>
                          </>
                        )
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      )}

      {/* FORMULARIOS ADICIONALES (NOTAS Y RECUPERACIONES) */}
      {anioActivo && puedeGestionar && (
        <div className="grid-inferior">
          <div className="card-form">
            <h3>📝 Cierre de Notas</h3>
            <form onSubmit={handleSubmitNotas}>
              <select value={formNotas.periodo_id} onChange={e => setFormNotas({ ...formNotas, periodo_id: e.target.value })} required>
                <option value="">Periodo...</option>
                {periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
              <input type="date" value={formNotas.fecha_inicio} onChange={e => setFormNotas({ ...formNotas, fecha_inicio: e.target.value })} required />
              <input type="date" value={formNotas.fecha_fin} onChange={e => setFormNotas({ ...formNotas, fecha_fin: e.target.value })} required />
              <button type="submit">Guardar</button>
            </form>
          </div>

          <div className="card-form">
            <h3>♻️ Recuperaciones</h3>
            <form onSubmit={handleSubmitRecuperacion}>
              <select value={formRecuperacion.periodo_id} onChange={e => setFormRecuperacion({ ...formRecuperacion, periodo_id: e.target.value })} required>
                <option value="">Periodo...</option>
                {periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
              <input type="date" value={formRecuperacion.fecha_inicio} onChange={e => setFormRecuperacion({ ...formRecuperacion, fecha_inicio: e.target.value })} required />
              <input type="date" value={formRecuperacion.fecha_fin} onChange={e => setFormRecuperacion({ ...formRecuperacion, fecha_fin: e.target.value })} required />
              <button type="submit">Guardar</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}